import Immutable from 'immutable';
import moment from 'moment';

import PublicParameterGroup from 'sharedreact/data/PublicParameterGroup';
import User from 'sharedreact/data/User';
import ClassFactory from 'sharedreact/utils/ClassFactory';

// in wfk used Preset, in webshuttle used Ticket

const Content: {
  id: string,
  name: string,
  ticketName: string,
  modificationDate: moment.Moment | null,
  user: User | null,
  description: string,
  values: Immutable.Map<string, any>,
  parameters: Immutable.List<PublicParameterGroup>
} = {
  id: '',
  name: '',
  ticketName: '',
  modificationDate: null,
  user: null,
  description: '',
  values: Immutable.Map(),
  parameters: Immutable.List()
};

class Ticket extends Immutable.Record(Content) {
  static createTemp() : Ticket {
    throw new Error('NotImplementedException');
  }

  static fromJS (json: object): Ticket {
    const object: Ticket = ClassFactory.createFromJson(json, Ticket); // a preset's id equal to null will be set to a unique "placeholder_preset<X>" where <X> is a number
    if (object.id.startsWith('placeholder_')) {
      // set the ticket name as the id for possible use in the PresetStore
      return object.setId(object.ticketName);
    }
    // if the preset has a real id (guid), don't change it because it must stay comparable with a modified preset signalled via a product's PublicParameterSettingsModified event
    return object;
  }

  get displayName (): string {
    return this.ticketName.replace(/^swft\//g, '');
  }

  setParameter (name: string, value: any): Ticket {
    return this.set('values', this.values.set(name, value));
  }

  getParameter (name: string): any {
    return this.values.get(name);
  }

  setId (id: string): Ticket {
    return this.set('id', id);
  }

  setName (name: string): Ticket {
    return this.set('ticketName', 'swft/' + name);
  }

  setDescription (description: string): Ticket {
    return this.set('description', description);
  }
}

export default Ticket;
